import HttpService from "@/common/ApiService";
import configuration from "@/../public/urlConfig.json";
import vue from "vue";

const http = new HttpService(vue.prototype.$config.tourBaseAddress);

require("linqjs");
const factory = () => ({
    cities: [],
    searchedItems:{}
});
export default {
    namespaced: true,
    state: factory(),
    mutations: {
        SetSearchedItems(state, item) {
            state.searchedItems = item;
        },
        SetCities(state, items) {
            if (Array.isArray(items)) {
                state.cities = items;
            } else {
                throw "array type mismatch";
            }
        },

        ResetState(state) {
            Object.assign(state, factory());
        }
    },
    getters: {

        GetSearchedItems(state) {
            return state.searchedItems;
        },
        GetCities: (state) => (search = "") => {
            if (typeof search === "undefined") {
                search = "".toString();
            } else {
                search = search
                    .toString()
                    .toLowerCase()
                    .trim();
            }

            if (typeof state.cities !== undefined && state.cities.length <= 0) return [];

            if (search.trim() === "" || search.length < 3)
                return state.cities.sort((t) => t.name);

            return state.cities
                .filter(
                    (t) =>
                        t.name
                            .toString()
                            .toLowerCase()
                            .includes(search) ||
                        t.description
                            .toString()
                            .toLowerCase()
                            .includes(search) ||
                        t.shortName
                            .toString()
                            .toLowerCase()
                            .includes(search) ||
                        t.tags.any((x) =>
                            x
                                .toString()
                                .trim()
                                .toLowerCase()
                                .includes(search)
                        )
                )
                .sort((t) => t.name);
        },
    },
    actions: {
    

         Searcheditems(context, item) {
            context.commit("SetSearchedItems", item);
        },
        ResetState(context) {
            context.commit("ResetState");
        }
    }
}